import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_MusicListItemTop = _resolveComponent("MusicListItemTop");

  const _component_MusicListItemList = _resolveComponent("MusicListItemList");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_MusicListItemTop, {
    itemPlayList: $setup.state.itemPlayList
  }, null, 8, ["itemPlayList"]), _createVNode(_component_MusicListItemList, {
    songList: $setup.state.songList,
    subscribedCount: $setup.state.itemPlayList.subscribedCount
  }, null, 8, ["songList", "subscribedCount"])], 64);
}